var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ServiceCategoryTitle"},[_c('h3',{staticClass:"title",attrs:{"id":"js-test__title"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.show_return)?_c('div',{attrs:{"id":"js-test__return"},on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":_vm.arrow}}),_vm._v(" "),_c('span',[_vm._v("Wróć")])]):_vm._e(),_vm._v(" "),(_vm.subtitle.length > 0)?_c('span',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e785d44","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/ServiceCategoryTitle/index.vue
// module id = 1468
// module chunks = 1